import { useState, useRef, Fragment } from "react";
import Config from "../../Config";
import Calendar from "../../calendar/Calendar";
import InputComboGrupa from "../../helpers/InputComboGrupaE";
import InputText from "../../helpers/InputText";
import InputTextArea from "../../helpers/InputTextArea";
import InputCombo from "../../helpers/InputCombo";
import MenuTable from "../../helpers/MenuTable";
import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import CalendarYearEShow from "./CalendarYearEShow";
import CalendarYearENew from "./CalendarYearENew";



function CalendarYearEM(props)
{

   var cData = Config.getFromBuffer(Config.cache_grups_emps,3600, props.userData );
    
   const [gr, setGr] = useState(cData);

   const [errTab, setErrTab] = useState([]);  //z info od serwera..

   const [refreshView, setRefreshView] = useState(props.userData.refreshView);
   const [tab, setTab] = useState(null);

   const [list, setList] = useState(null);

   const tabRef = useRef(0); //do druku

 

   var dt = new Date();

   var strM = (dt.getMonth()+1)+"";
   if(strM.length == 1) strM = "0" + strM;

   var strD = dt.getDate()+"";
   if(strD.length == 1) strD = "0" + strD;

   var dateX  = dt.getFullYear()+"-"+strM+"-"+strD;

   
   const [view, setView] = useState('list');

   
   
   const [filter, setFilter] = useState(null);
   const [filterParam, setFilterParam] = useState({   
                
       p_grupa_id:  '_x_',
       day: dateX,

       limit: 50,
       page: 1,
       pages: 1,
   });
 
   const clickOnDay = (date,title) => {      
      
      if( date != null && date.length > 2)
      {
         //setFilterParam({...filterParam, ["day"]: date,["p_grupa_id"]:'_x_' });                  
         setFilterParam({...filterParam, ["day"]: date,["p_grupa_id"]:'_x_' });    

         getList(date);
      }
    

  }

   const getGr = () => {
       
 
      props.mainView.setProgress(-2);

  

      fetch( Config.url + '/rest_v1_employessModule,gr', {
         method: 'POST', 
         body: JSON.stringify({}), 
         headers: {
            'Content-Type': 'application/json',                    
            'X-Api-Key': props.userData.apiKey,
            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
            '_p_dziecko_id_': props.userData.p_dziecko_id,
            '_sec_key_': Config.genXKey() ,
         }
      })
      .then(res => res.json() )
      .then(res => { 

                  props.mainView.setProgress(-1);        
                  if(res._sys_ == undefined)
                  {
                     props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                  }else
                  if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                  {
                     props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                  }else    
                  {
                     setGr(res.result);      
                     
                     Config.setToBuffer(Config.cache_grups, res.result, props.userData);
                              
                  }

         } )
         .catch(err => {          
                  props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                  props.mainView.setProgress(-1);
         });
               

         return false;
   }

   if( gr == null ||  gr.length == 0 )
      {
              getGr();
              
              return <div></div>;                 
              
      }




  const getList = (dt ) => {
        

   var req = {
      ym: filterParam.day
   };

   if(dt != null )
   {
      req = {
         ym: dt
      };
   }


    props.mainView.setProgress(-2);     

    fetch( Config.url + '/rest_v1_employessModule,kalendarz_list', {
        method: 'POST', 
        body: JSON.stringify(req), 
        headers: {
            'Content-Type': 'application/json',                    
            'X-Api-Key': props.userData.apiKey,
            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
            '_p_dziecko_id_': props.userData.p_dziecko_id,
            '_sec_key_': Config.genXKey() ,
        }
     })
     .then(res => res.json() )
     .then(res => { 

                props.mainView.setProgress(-1);        
                if(res._sys_ == undefined)
                {
                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                }else
                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                {
                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                }else    
                {
                    setList(res.result);      
                          
                   
                }
     } )
     .catch(err => {          
                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                props.mainView.setProgress(-1);
     });
               

     return false;
}



  const valChecker = (fields) => {

   var allValid = true;

         
   console.log(list);

   Object.entries(fields).forEach(function(entry) {

       var xKey    = entry[0];
       var xValue  = entry[1];                    

       var xValidName = xKey + "_valid";

       if(fields[xValidName] == false)
       {
           allValid = false;
           console.log("Error field: " + xKey);
       }
       
     });
   
     return allValid;

}

  

  const changeView = (e ) => {
   var v = e.currentTarget.getAttribute('v');
   var id = e.currentTarget.getAttribute('id');
   var p_grupa_id = e.currentTarget.getAttribute('p_grupa_id');

  
   setView({...view, ["v"]:v, ["id"]:id,['p_grupa_id']:p_grupa_id });
}


   const onBack = ( ) => {                
   setView({...view, ["v"]:"list", ["id"]:-1 });       
   getGr();
   getList();
   }

   

   var daysReview = new Array();

   daysReview.push({
         date: filterParam.day,
         title: "wybrano " + filterParam.day,
         className: "selected",
   });


   
   var dayContent = null;



   if(refreshView != props.userData.refreshView)
      {         
          setRefreshView( props.userData.refreshView);
          setTab(null);
          setFilterParam({...filterParam,["p_grupa_id"]:"_x_" });
      }


      

      if(list == null)
      {
         setList([]);
         getList(null);
         return <div></div>
      }



   var tn = [
      { v: 0, title: 'Nie' }, 
      { v: 1, title: 'Tak, dzień wcześniej (rano) ' }, 
   ];

   var tnX = [
      { v: 0, title: 'Nie' }, 
      { v: 1, title: 'Tak ' }, 
   ];

   
   if(view.v == 'show')
   {   
      var searchRow = null;
      for(var k=0; k<list.length; k++)
      {
         if(list[k].id == view.id) { searchRow = list[k]; break; }
      }

      return <CalendarYearEShow userData={props.userData} mainView={props.mainView} p_grupa_id={view.p_grupa_id} row={searchRow} onBack={onBack}    />    
         
   }

   if(view.v == 'new')
   {   
      return <CalendarYearENew userData={props.userData} mainView={props.mainView} p_grupa_id={view.p_grupa_id} row='' onBack={onBack}    />    
            
   }

   var table = '';    
   
   
     



   table = gr.map( (grupa, ix) => {

      var wydarzenia = list.filter(list =>list.grupy.some(grupa_wew => grupa_wew.id ===grupa.v)); 


         if(grupa.v!='_x_')

         
         if(filterParam.p_grupa_id=='_x_' || filterParam.p_grupa_id==grupa.v)    
         {
            return <div className='mobile_table'>
               <div className="mobile_th"  onClick={changeView} id='-1' p_grupa_id={grupa.v} v="new" >{grupa.title} (+)</div>
               <div className="mobile_tb">
                        {
                            wydarzenia.map( (wydarzenie, ix2) => {

                                return <div onClick={changeView} id={wydarzenie.id} p_grupa_id={grupa.v} v="show" className='calendar_row'>
                                    <div  className="calendar_row_title ">{wydarzenie.temat_dnia}</div>
                                    <div className="calendar_row_date ">{wydarzenie.dzien}</div> 
                                </div>
                            })
                        }    
                        </div>
                    </div>
                }
                
                

            }
        )


   return   <div className="view_content">
 


                           <div className="bg_center">


                     
                              
                           {table}
                              
                               
                           </div>

   </div>
}

export default CalendarYearEM;